export default __webpack_public_path__ + "static/media/case-XC40.99c9d35b.jpg";